import { Entity } from 'webpanel-admin';
import { api } from './api';

export const documentCategory = new Entity({
  name: 'DocumentCategory',
  title: 'Kategorie dokumentu',
  icon: 'tags',
  dataSource: api,
  searchable: true
}).inputField('name', {
  title: 'Název',
  sortable: true,
  filter: true
});



// WEBPACK FOOTER //
// ./src/model/document-category.tsx